import { useEffect, useState } from 'react'
import { Button, Input, Label } from 'reactstrap'
import { faClose, faSave } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

//Components
import ModalCustomized from '../../../../components/Modal/Modal'
import TextField from '../../../../components/TextField'

//Context
import { useAuth } from '../../../../context/auth'
import { showMessage } from '../../../../helpers/message'
import analiseInfracao_api from '../../../../api/analiseInfracao_api'
import infracoes_api from '../../../../api/infracoes_api'

export default function ResertInfracao({ infracao, loadInfracao, isOpenModal, handleCloseModal }) {
    const { setLoading } = useAuth();

    //State para controlar se poder cancelar ou não a infração
    const [listaEtapasPercorridasInfracoes, setEtapasPercorridasInfracoes] = useState([]);


    const [resertInfracao, setResertInfracao] = useState({
        motivo: "",
        fiscalizacaoInfracao_Id: "",
        checkConfirmaResert: false,
        roteiroFiscalizacaoInfracao_IdEtapaOrigem: ""
    })

    function onChangeResertInfracao(e) {
        const { name, value } = e.target;
        setResertInfracao({
            ...resertInfracao,
            [name]: value
        })
    }

    async function loadEtapasPercorridasInfracao(infracao_Id) {
        setLoading(true)
        try {
            const { data } = await infracoes_api.GetEtapasPercorridas(infracao_Id);

            setEtapasPercorridasInfracoes(data ?? [])
        } catch (error) {
            showMessage("Error", error?.message ?? "Erro na operação", "error", null)
        }
        finally {
            setLoading(false)
        }
    }

    async function handleSubmitResertInfracao() {
        if (!resertInfracao.roteiroFiscalizacaoInfracao_IdEtapaOrigem)
            return showMessage("Aviso", "Selecione a etapa para a qual deseja retornar!", "warning", null);

        setLoading(true)
        try {
            await analiseInfracao_api.ResetInfracao(resertInfracao);
            await loadInfracao()
            await loadEtapasPercorridasInfracao(resertInfracao.fiscalizacaoInfracao_Id);
            showMessage("Sucesso", "Sucesso na operação", "success", handleCloseModal)
        } catch (error) {
            showMessage("Error", error?.message ?? "Erro na operação", "error", null)
        }
        finally {
            setLoading(false)
        }
    }

    const onChangeEtapa = (value, e) => {
        const _resertInfracao = {
            ...resertInfracao,
            [e.name]: value ? value.value.toString() : null,
        };
        setResertInfracao(_resertInfracao);
    };


    useEffect(() => {
        if (!isOpenModal) return;

        setResertInfracao({
            motivo: "",
            fiscalizacaoInfracao_Id: infracao.id,
            checkConfirmaResert: false,
            roteiroFiscalizacaoInfracao_IdEtapaOrigem: ""
        })
        loadEtapasPercorridasInfracao(infracao.id)
    }, [isOpenModal])

    return (
        <>
            <ModalCustomized
                toggle={handleCloseModal}
                isOpen={isOpenModal}
                size={'lg'}
                fullscreen={"lg"}
                widthPadrao={false}
                title={"Reserta Infração"}
            >
                <span className='text-danger'>ATENÇÃO: Tem certeza que deseja resetar a infração?</span>

                <div className='w-100 my-4'>
                    <TextField
                        name={"roteiroFiscalizacaoInfracao_IdEtapaOrigem"}
                        label={"* Etapa"}
                        searchable
                        type={"select"}
                        options={listaEtapasPercorridasInfracoes.map((c) => {
                            return {
                                value: c.id.toString(),
                                label: c.descricao,
                            };
                        })}
                        value={listaEtapasPercorridasInfracoes
                            .map((c) => {
                                return {
                                    value: c.id.toString(),
                                    label: c.descricao,
                                };
                            })
                            .filter((v) => v.value == resertInfracao?.roteiroFiscalizacaoInfracao_IdEtapaOrigem)}
                        onChange={onChangeEtapa}
                    />
                </div>

                <TextField
                    name={"motivo"}
                    label={"Motivo"}
                    type={"textarea"}
                    maxLength={500}
                    value={resertInfracao.motivo}
                    onChange={onChangeResertInfracao}
                />

                <div className='d-flex aling-items-center gap-2 my-2'>
                    <Input
                        type="checkbox"
                        onChange={(e) => setResertInfracao({
                            ...resertInfracao,
                            checkConfirmaResert: e.target.checked
                        })}
                        value={resertInfracao.checkConfirmaResert}
                        name='checkConfirmaResert'
                    />{" "}
                    <Label check>
                        Confirmo que ao resetar a infração todos os dados do processo de análise serão apagados e o processo será reiniciado.
                    </Label>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-2">
                    <Button
                        color="danger"
                        onClick={handleCloseModal}
                    >
                        <FontAwesomeIcon icon={faClose} /> Cancelar
                    </Button>
                    <Button
                        color="success"
                        onClick={handleSubmitResertInfracao}
                        disabled={!resertInfracao.checkConfirmaResert}
                    >
                        <FontAwesomeIcon icon={faSave} /> Confirmar
                    </Button>
                </div>
            </ModalCustomized>
        </>
    )
}
